import { render, staticRenderFns } from "./AppContainer.vue?vue&type=template&id=47782a4f&scoped=true&"
import script from "./AppContainer.vue?vue&type=script&lang=ts&"
export * from "./AppContainer.vue?vue&type=script&lang=ts&"
import style0 from "./AppContainer.vue?vue&type=style&index=0&id=47782a4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47782a4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47782a4f')) {
      api.createRecord('47782a4f', component.options)
    } else {
      api.reload('47782a4f', component.options)
    }
    module.hot.accept("./AppContainer.vue?vue&type=template&id=47782a4f&scoped=true&", function () {
      api.rerender('47782a4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppContainer/AppContainer.vue"
export default component.exports